import React from "react";
import "../PCategory/PCategory.css";
const PCategory = () => {
  return (
    <>
      <div className="main-pc">
        <div class="ribbon2" data-aos="fade-left">
          Popular Categories
        </div>
        <div className="category-body">
          <div className="category">
            <div className="item" data-aos="fade-right">
              <span className="title">Supplement</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/supple.webp" alt />
            </div>
            <div className="item" data-aos="fade-left">
              <span className="title">Diabetes</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/diabetis.webp" alt />
            </div>
            <div className="item" data-aos="fade-right">
              <span className="title">First Aid</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/first.webp" alt />
            </div>
            <div className="item" data-aos="fade-left">
              <span className="title">Heart</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/heart.webp" alt />
            </div>
            <div className="item" data-aos="fade-right">
              <span className="title">Limbs & Joints</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/limbs.webp" alt />
            </div>
            <div className="item" data-aos="fade-left">
              <span className="title">Eye</span>
              <span className="link" href="#">
                Check Out
              </span>
              <img className="img1" src="/eye.webp" alt />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PCategory;
